import React from 'react';

import { UserDetail } from 'components';

export const PageUserDetail = () => (
  <UserDetail />
);
